import mongoose from "mongoose";
import { IUserData } from "../../interfaces/userData.interface";
import { IDepartment } from "../../interfaces/department.interface";

// Currently these forms rendered as remark only
export const enquiryForms = [
  "Flight Enquiry",
  "Hotel Enquiry",
  "Tour Enquiry",
  "Visa Enquiry",
  "Other Enquiry",
  "Bus Enquiry",
  "Train Enquiry",
  "Cruise Enquiry",
  "Insurance Enquiry",
];

export const onlyRemarkForms = [
  "Bus Enquiry",
  "Train Enquiry",
  "Insurance Enquiry",
  "Cruise Enquiry",
  "Tour Enquiry",
];

export type EnumEnquiryTypes =
  | "Flight Enquiry"
  | "Hotel Enquiry"
  | "Tour Enquiry"
  | "Visa Enquiry"
  | "Other Enquiry"
  | "Bus Enquiry"
  | "Train Enquiry"
  | "Cruise Enquiry"
  | "Insurance Enquiry";

export type EnumEnquiryStatus =
  | "open"
  | "pending"
  | "resolved"
  | "closed"
  | "followuppending";
export type EnumCallbackEnquiryStatus = "done" | "pending";

// ["low", "medium", "high"]
export type EnumEnquiryPriority = "low" | "medium" | "high";
export type EnumRemarkType = "public" | "internal";

export interface IEnquiryRemark {
  remark: string | undefined;
  enquiryId: number | undefined;
  remarkType: EnumRemarkType | undefined;
}

export interface DbSchemaEnquiryCommon {
  siteId: mongoose.Schema.Types.ObjectId;
  mysqlUserId: number;
  queryStatus: EnumEnquiryStatus;
  priority: EnumEnquiryPriority;
  assignedTo_mysqlUserId?: number;
  // type: EnumEnquiryTypes;
}
export interface IVisaInfo {
  country: string;
  visaCategory: EnumVisaCategory;
}
export interface IFlightEnquiry extends ICommonEnquiry {
  passengers: Passenger[];
  segments: Segment[];
}
export interface IOtherEnquiry extends ICommonEnquiry {
  passengers: Passenger[];
}
export interface IVisaEnquiry extends ICommonEnquiry {
  visaEnquires: IVisaInfo[];
}
export interface IHotelEnquiry extends ICommonEnquiry {
  city: string | undefined;
  rooms: number | undefined;
  checkin: Date | undefined;
  checkout: Date | undefined;
  isFlexible?: boolean;
  category: string;
  hotelName: string | null;
}

export interface ICommonEnquiry {
  remark: string | undefined;
  type: EnumEnquiryTypes;
  noOfAdult?: number;
  noOfChild?: number;
  noOfInfant?: number;
  title?: string;
}

////// enquiry type for db use
export type EnumVisaCategory = "tourist" | "business" | "visitor";

export type EnumPaxType = "Adult" | "Child" | "Infant";
export type EnumPaxTitle = "Mr" | "Mrs" | "Ms" | "Miss" | "Master" | "Dr";
export interface DbSchemaForRemark {
  createdAt: Date;
  updatedAt: Date;
  siteId: string;
  userId: number;
  uuid: string;
  userData: any;
}

export interface IFlightEnquiry_DB
  extends IFlightEnquiry,
    DbSchemaEnquiryCommon {}

export interface IEnquiryRemark_DB extends IEnquiryRemark, DbSchemaForRemark {}

export interface Passenger {
  id?: number;
  enquiryId?: number;
  type: EnumPaxType;
  title: EnumPaxTitle;
  firstName: string;
  lastName: string;
  DOB?: string;
  passportNumber?: string;
  passportExpiry?: string;
  passportCountry?: string;
  createdAt?: Date;
  updatedAt?: Date;
  isPassportWindow?: boolean;
}
export interface UserData {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
}

export interface Segment {
  origin: string;
  destination: string;
  departureDate: string;
  isFlexible?: boolean;
  flightNumber: string | null;
}

//////////////////

export enum EnumQuerySubjects {
  "Bus Enquiry" = "Bus Enquiry",
  "Cruise Enquiry" = "Cruise Enquiry",
  "Hotel Enquiry" = "Hotel Enquiry",
  "Insurance Enquiry" = "Insurance Enquiry",
  "Train Enquiry" = "Train Enquiry",
}
export interface IQueryFilter {
  queryStatus?: EnumEnquiryStatus;
  priority?: EnumEnquiryPriority;
  type?: EnumEnquiryTypes;
  assignedToStaffUUID?: string;
  searchByCustomer?: string;
  departmentId?: number;
}
export interface ICallbackQueryFilter {
  isCallDone?: boolean;
  requestForStaffUUID?: string;
  customerUUID?: string;
  departmentId?: number;
  id?: number;
}

export interface IEnquiriesResponse {
  currentPage: number;
  perPage: number;
  totalPages: number;
  totalRecords: number;
  currentPageRecords: IEnquiry[];
  departments: IDepartment[];
  userType?: string;
  userId?: number;
  uuid?: string;
}

export interface IgetEnquiryProps {
  pageNumber?: number;
}

export interface IEnquiry {
  type: EnumEnquiryTypes;
  customerDetails: CustomerDetails;
  id: number;
  enquiryForm?: EnquiryForm;
  siteId?: string;
  subject?: EnumEnquiryTypes;
  queryStatus?: EnumEnquiryStatus;
  priority?: EnumEnquiryPriority;
  assignedTo_userId?: number;
  passengers: Passenger[];
  flightSegments: Segment[];
  visaEnquires: IVisaInfo[];
  hotel: IHotelEnquiry;
  remark: string;
  createdAt: string;
  uuid: string;
  noOfAdult?: number;
  noOfChild?: number;
  noOfInfant?: number;
  departmentId: number | null;
  userData: IUserData;
  assignedToStaffUUID: any;
  createdByStaffData: IUserData;
  assignedToStaffData: IUserData;
  title?: string;
  fullName?: string;
  phoneCode?: string;
  phoneNumber?: string;
  email?: string;
}

interface CustomerDetails {
  name: string;
  email: string;
  phone: string;
}

interface EnquiryForm {
  destination?: string;
  departureDate?: Date;
  returnDate?: Date;
  noOfPax?: string;
  fromCityDetails?: string;
  toCityDetails?: string;
  travelDate?: string;
  class?: string;
  city?: string;
  rooms?: number | string;
  guest?: number | string;
  checkin?: Date;
  checkout?: Date;
  cruiseLines?: string;
  dates?: string;
  nights?: string;
  durationInDays?: string;
}
